import StackCaptureError from './StackCaptureError';

export default class SentryScopedError extends StackCaptureError {
  constructor(sentryScope, ...params) {
    super(...params);

    this.sentryScope = sentryScope;
  }
}
